import React, { FC } from 'react';
import Box, { BoxProps } from '@material-ui/core/Box';

import { AlertCssProps } from './types';
import { useStyles } from './Alert.styles';

export const Alert: FC<AlertCssProps & BoxProps> = ({ type, ...rest }) => (
  <Box {...rest} className={useStyles({ type }).root} />
);
